import { createFileRoute } from "@tanstack/react-router";
import { EmentasCatalogoPage } from "@/components/ementas-catalogo/EmentasCatalogoPage";

const URL = "https://fisioemortopedia.com.br/ementas";
const TITLE = "Ementas das pós-graduações · Fisio em Ortopedia";
const DESC = "Baixe a ementa completa de cada pós-graduação da FEO: Ortopedia, Dor, Esporte, Gerontologia, Traumatologia e Prescrição de Exercícios.";

export const Route = createFileRoute("/ementas")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { name: "robots", content: "noindex,nofollow" },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: URL },
      { name: "twitter:card", content: "summary" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESC },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: () => <EmentasCatalogoPage theme="black" />,
});
